import axios from "axios";
import React from "react";
import { Card } from "react-bootstrap";
import toastr from "toastr";
import { CustomLoading } from "components/CustomLoading";
import "../../styles/Reports.css";
import HsaBenefitUtilizationTable from "./HsaBenefitUtilizationTable";
import LsaBenefitUtilizationTable from "./LsaBenefitUtilizationTable";
import HsaDisbursementReportTable from "./HsaDisbursementReportTable";
import LsaDisbursementReportTable from "./LsaDisbursementReportTable";
import DivisionsReportTable from "./DivisionReportTable";
import CostCentresReportTable from "./CostCentresReportTable";
import LifestyleTaxableReportTable from "./LifestyleTaxableReportTable";
import FundingActivityAndTransactionsTable from "./FundingActivityAndTransactionsTable";
import MonthlySummaryTable from "./MonthlySummaryTable";
import FlexSelectionReportTable from "./FlexSelectionReport";
import MonthlyInvoice from "./MonthlyInvoice";
import HsaCustomCategoriesReport from "./HsaCustomCategoriesReport";
import LsaCustomCategoriesReport from "./LsaCustomCategoriesReport";
import CustomCatClaimSummaryReport from "./CustomCatClaimSummaryReport";
import TeladocReportTable from "./TeladocReportTable";
import TeladocFundingActivityTable from "./TeladocFundingActivityTable";
import CorehealthReportTable from "./CorehealthReportTable";
import CorehealthFundingActivityTable from "./CorehealthFundingActivityTable";
import Accordion from "react-bootstrap/Accordion";

export default class Reports extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            divisions: [],
            costCentres: [],
            benefitYearOptions: [],
            currentListItem: "Funding Activity and Transactions",
            isMigratedCompany: false,
            pendingandactivebenefitYearOptions: [],
        };

        this.setCurrentItem = this.setCurrentItem.bind(this);
        this.fetchDivisionsData = this.fetchDivisionsData.bind(this);
        this.fetchCostCentresData = this.fetchCostCentresData.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});
        this.getBenefitYearOptions();
        this.getPendingAndActiveBenefitYearOptions();

        if (this.props.showDivisions) {
            this.fetchDivisionsData();
        }
        if (this.props.showCostCentres) {
            this.fetchCostCentresData();
        }
        this.checkIsMigratedCompany();

        if (this.props.teladocOnly) {
            this.setState({ currentListItem: 'Teladoc Invoice' });
        }
    }

    checkIsMigratedCompany() {
        axios.get("/api/PlanAdmin/ismigratedcompany?policyId=" + this.props.policyId)
            .then(res => {
                if (res.data.success) {
                    this.setState({ 
                        isMigratedCompany: res.data.isMigratedCompany,
                        loading: false
                    });
                } else {
                    toastr.error(res.data.message, "Error");
                }
            }
            )
            .catch(error => {
                toastr.error(error, "Error");
            });
    }

    getBenefitYearOptions = () => {
        axios.get("/api/PlanAdmin/benefityearsoptions?policyId=" + this.props.policyId)
            .then(res => {
                if(res.data.success) {
                    this.setState({
                        benefitYearOptions: res.data.benYearOptions,
                    });
                } else {
                    toastr.error(res.data.message, "Error");
                }
            })
            .catch(err => {
                toastr.error(err, "Error");
            });
    }

    getPendingAndActiveBenefitYearOptions = () => {
        axios.get("/api/Reports/pendingandactivebenefityearsoptions?policyId=" + this.props.policyId)
            .then(res => {
                if(res.data.success) {
                    this.setState({
                        pendingandactivebenefitYearOptions: res.data.benYearOptions,
                    });
                } else {
                    toastr.error(res.data.message, "Error");
                }
            })
            .catch(err => {
                toastr.error(err, "Error");
            });
    }

    setCurrentItem = (item) => {
        this.setState({currentListItem: item});
    }

    fetchDivisionsData = () => {
        axios.get(`/api/PlanAdmin/divisions?policyId=${this.props.policyId}`)
            .then(res => {
                if (res.data.success) {
                    this.setState({ 
                        divisions: res.data.divisions,
                    });
                } else {
                    toastr.error(res.data.message, "Error");
                }
            })
            .catch(error => {
                toastr.error(error, "Error");
            });
    }

    fetchCostCentresData = () => {
        axios.get(`/api/PlanAdmin/costcentres?policyId=${this.props.policyId}`)
            .then(res => {
                if (res.data.success) {
                    this.setState({ 
                        costCentres: res.data.costCentres,
                    });
                } else {
                    toastr.error(res.data.message, "Error");
                }
            })
            .catch(error => {
                toastr.error(error, "Error");
            });
    }

    render() {
        let groupedList = {
    "Funding / Accounting": [],
    "Statistics / Usage": [],
    "Monthly Billing": []
};
        let contents = null;
        if (this.state.loading) {
            contents = (<CustomLoading />);
        } else
        {
            let listGroup = [];
            if(!this.props.teladocOnly) {
                groupedList["Funding / Accounting"].push("Funding Activity and Transactions");
                groupedList["Funding / Accounting"].push("Monthly Statement / Invoice");
                groupedList["Funding / Accounting"].push("Claim Summary");
                if (this.props.showHSACustomCat || this.props.showLSACustomCat) {
                    groupedList["Funding / Accounting"].push("Enhanced Benefits Claim Summary Report");
                }
                if (this.props.showLSAReports) {
                    groupedList["Funding / Accounting"].push("Lifestyle Taxable Report");
                }
            }
            if(this.props.hasTeladoc || this.props.hasTeladocInvoices) {
                groupedList["Monthly Billing"].push("Teladoc Funding Activity");
                groupedList["Monthly Billing"].push("Teladoc Invoice");
            }
            if(this.props.hasCorehealth || this.props.hasCorehealthInvoices) {
                groupedList["Monthly Billing"].push("Corehealth Funding Activity");
                groupedList["Monthly Billing"].push("Corehealth Invoice");
            }
            if (this.props.showHSAReports) {
                groupedList["Statistics / Usage"].push("HSA Benefit Utilization");
                groupedList["Statistics / Usage"].push("HSA Disbursement Report");
                if (this.props.showHSACustomCat) {
                    groupedList["Statistics / Usage"].push("HSA Enhanced Benefits Report");
                }
            }
            if (this.props.showLSAReports) {
                groupedList["Statistics / Usage"].push("LSA Benefit Utilization");
                groupedList["Statistics / Usage"].push("LSA Disbursement Report");
                if (this.props.showLSACustomCat) {
                    groupedList["Statistics / Usage"].push("LSA Enhanced Benefits Report");
                }
            }
            if(this.props.showHSACustomCat)
            {
                listGroup.push("Enhanced Benefits Claim Summary Report");
            }
            if (this.props.showHSAReports) {
                listGroup.push("HSA Disbursement Report");
            }
            if (this.props.showLSAReports) {
                listGroup.push("LSA Disbursement Report");
            }
            if (this.props.showLSAReports) {
                listGroup.push("Lifestyle Taxable Report");
            }
            if (this.props.showDivisions && !this.props.hasTeladoc) {
                groupedList["Statistics / Usage"].push("Divisions Report");
            }
            if (this.props.showCostCentres && !this.props.hasTeladoc) {
                groupedList["Statistics / Usage"].push("Cost Centres Report");
            }
            if (this.props.showFlexReports) {
                groupedList["Statistics / Usage"].push("Flex Selection Report");
            }

            let tableContents = null;
            if (this.state.currentListItem === "HSA Benefit Utilization") {
                tableContents = <HsaBenefitUtilizationTable 
                                    benefitYearOptions={this.state.benefitYearOptions} 
                                    policyId={this.props.policyId}
                                    showCostCentres={this.props.showCostCentres}
                                    costCentres={this.state.costCentres}
                                    showDivisions={this.props.showDivisions}
                                    divisions={this.state.divisions}
                                />

            } else if (this.state.currentListItem === "LSA Benefit Utilization") {
                tableContents = <LsaBenefitUtilizationTable 
                                    benefitYearOptions={this.state.benefitYearOptions} 
                                    policyId={this.props.policyId}
                                    isMigratedCompany={this.state.isMigratedCompany}
                                    showCostCentres={this.props.showCostCentres}
                                    costCentres={this.state.costCentres}
                                    showDivisions={this.props.showDivisions}
                                    divisions={this.state.divisions}
                                />

            } else if (this.state.currentListItem === "HSA Disbursement Report") {
                tableContents = <HsaDisbursementReportTable
                                    policyId={this.props.policyId}
                                    benefitYearOptions={this.state.benefitYearOptions}
                                />

            } else if (this.state.currentListItem === "LSA Disbursement Report") {
                tableContents = <LsaDisbursementReportTable 
                                    policyId={this.props.policyId}
                                    benefitYearOptions={this.state.benefitYearOptions}
                                />

            } else if (this.state.currentListItem === "Divisions Report") {
                tableContents = <DivisionsReportTable 
                                    policyId={this.props.policyId} 
                                    divisions={this.state.divisions}
                                />

            } else if (this.state.currentListItem === "Cost Centres Report") {
                tableContents = <CostCentresReportTable 
                                    policyId={this.props.policyId} 
                                    costCentres={this.state.costCentres}
                                />

            } else if (this.state.currentListItem === "Lifestyle Taxable Report") {
                tableContents = <LifestyleTaxableReportTable policyId={this.props.policyId}/>

            } else if (this.state.currentListItem === "Funding Activity and Transactions") {
                tableContents = <FundingActivityAndTransactionsTable policyId={this.props.policyId}/>

            } else if (this.state.currentListItem === "Claim Summary") {
                tableContents = <MonthlySummaryTable policyId={this.props.policyId}/>

            } else if (this.state.currentListItem === "Flex Selection Report") {
                tableContents = <FlexSelectionReportTable 
                                    benefitYearOptions={this.state.pendingandactivebenefitYearOptions} 
                                    policyId={this.props.policyId}
                                />
                                
            } else if (this.state.currentListItem === "Monthly Statement / Invoice") {
                tableContents = <MonthlyInvoice 
                                    showLSAReports={this.props.showLSAReports} 
                                    showHSAReports={this.props.showHSAReports} 
                                    policyId={this.props.policyId} 
                                />
            } else if (this.state.currentListItem === "HSA Enhanced Benefits Report") {
                tableContents = <HsaCustomCategoriesReport
                                    benefitYearOptions={this.state.benefitYearOptions} 
                                    policyId={this.props.policyId}
                                />
            } else if (this.state.currentListItem === "LSA Enhanced Benefits Report") {
                tableContents = <LsaCustomCategoriesReport
                                    benefitYearOptions={this.state.benefitYearOptions} 
                                    policyId={this.props.policyId}
                                />
            } else if (this.state.currentListItem === "Enhanced Benefits Claim Summary Report") {
                tableContents = <CustomCatClaimSummaryReport
                                    benefitYearOptions={this.state.benefitYearOptions} 
                                    policyId={this.props.policyId}
                                />
            }
            else if (this.state.currentListItem === "Teladoc Funding Activity") {
                tableContents =  <TeladocFundingActivityTable
                    policyId={this.props.policyId}
                />
            }
            else if (this.state.currentListItem === "Corehealth Funding Activity") {
                tableContents =  <CorehealthFundingActivityTable
                    policyId={this.props.policyId}
                />
            }
            else if (this.state.currentListItem === "Corehealth Invoice") {
                tableContents =  <CorehealthReportTable
                    policyId={this.props.policyId}
                />
            }
            else if (this.state.currentListItem === "Teladoc Invoice") {
                    tableContents =  <TeladocReportTable
                        policyId={this.props.policyId}
                    />
            }

            contents = (
                <div className="ktm-reports">
                    <Accordion defaultActiveKey="0" className="ktm-reports-sidebar-list">
                        {Object.entries(groupedList)
                         .filter(([_, items]) => items.length > 0)
                         .map(([category, items], groupIndex) => (
                            <Accordion.Item eventKey={groupIndex.toString()} key={category}>
                                <Accordion.Header>{category}</Accordion.Header>
                                <Accordion.Body style={{ padding: "0" }}>
                                    <ul className="list-unstyled mb-0">
                                        {items.map((item) => (
                                            <li key={item}
                                                className="list-group-item"
                                                style={this.state.currentListItem === item ? { backgroundColor: "#848f99", color: "white", cursor: "pointer" } : { cursor: "pointer" }}
                                                onClick={() => this.setCurrentItem(item)}
                                            >
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                    <Card className="ktm-reports-content">{tableContents}</Card>
                </div>
            );
        }
        
        return (
            <>
            {contents}
            </>
        );
    }
}